import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Shield, ShoppingBag, Mountain, GraduationCap, TrendingUp, Home, Plane, Factory } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { ListingsComingSoon } from '../components/ListingsComingSoon';
const placeholderListings = [{
  id: 1,
  price: '$385,000',
  address: '3421 Aliante Pkwy',
  area: 'Aliante',
  beds: 3,
  baths: 2,
  sqft: '1,750',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 2,
  price: '$425,000',
  address: '6712 Tee Box Ave',
  area: 'North Las Vegas',
  beds: 4,
  baths: 2.5,
  sqft: '2,100',
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
}, {
  id: 3,
  price: '$510,000',
  address: '2890 Elkhorn Ridge Dr',
  area: 'Elkhorn Springs',
  beds: 4,
  baths: 3,
  sqft: '2,450',
  image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop'
}];
export function NorthLasVegasPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white" data-id="element-563">
      <section className="relative h-[70vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-564">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1512915922686-57c11dde9b6b?q=80&w=2946&auto=format&fit=crop")'
      }} data-id="element-565">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-566"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80" data-id="element-567"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-568">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-569">
            <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-570">
              Community Spotlight
            </span>
            <h1 className="text-5xl md:text-7xl text-white font-serif mb-6 leading-tight" data-id="element-571">
              North Las Vegas
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto" data-id="element-572">
              An emerging market with brand-new communities, exceptional value,
              and tremendous investment potential.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-573">
        <div className="max-w-7xl mx-auto" data-id="element-574">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-575">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-576">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-577">
                The Valley's{' '}
                <span className="italic text-gold" data-id="element-578">Best-Kept Secret</span>
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-579">
                <p data-id="element-580">
                  North Las Vegas has undergone a remarkable transformation over
                  the past decade, evolving from a quiet suburb into one of the
                  fastest-growing cities in Nevada. With a population exceeding
                  270,000, it offers some of the best real estate value in the
                  entire Las Vegas Valley.
                </p>
                <p data-id="element-581">
                  The city is home to brand-new master-planned communities like
                  Aliante, Elkhorn Springs, and the rapidly developing areas
                  near the Las Vegas Motor Speedway. Buyers can find beautiful
                  new-construction homes starting in the mid-$300Ks —
                  significantly below comparable homes in Summerlin or
                  Henderson.
                </p>
                <p data-id="element-582">
                  North Las Vegas is also a major economic hub, home to Nellis
                  Air Force Base, the VA Medical Center, Amazon distribution
                  centers, and a growing industrial corridor that's attracting
                  major employers and driving property appreciation.
                </p>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-6" data-id="element-583">
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-584">
                <TrendingUp className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-585" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-586">Top</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-587">
                  Appreciation
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-588">
                <Home className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-589" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-590">New</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-591">
                  Construction
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-592">
                <Factory className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-593" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-594">
                  Major
                </h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-595">
                  Job Growth
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-596">
                <Plane className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-597" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-598">
                  Nellis
                </h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-599">
                  Air Force Base
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Communities */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-600">
        <div className="max-w-7xl mx-auto" data-id="element-601">
          <div className="text-center mb-16" data-id="element-602">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-603">
              New Development
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-604">
              Master-Planned Communities
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-605">
            {[{
            name: 'Aliante',
            price: '$350K - $550K',
            desc: 'A stunning master-planned community with an 18-hole golf course, nature discovery park, casino resort, and miles of walking trails.',
            img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
          }, {
            name: 'Elkhorn Springs',
            price: '$380K - $600K',
            desc: 'A newer community offering modern floor plans, community parks, and excellent access to the 215 Beltway and I-15.',
            img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
          }, {
            name: 'Tule Springs',
            price: '$400K - $650K',
            desc: 'Adjacent to the Tule Springs Fossil Beds National Monument, offering unique desert living with modern amenities.',
            img: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
          }].map((n, idx) => <motion.div key={n.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white p-6 shadow-sm border border-warmGray-dark" data-id="element-606">
                <img src={n.img} alt={n.name} className="w-full h-48 object-cover mb-4" data-id="element-607" />
                <div className="flex justify-between items-start mb-3" data-id="element-608">
                  <h3 className="text-xl font-serif text-charcoal" data-id="element-609">{n.name}</h3>
                  <span className="text-xs font-medium text-gold bg-gold/10 px-2 py-1 rounded whitespace-nowrap" data-id="element-610">
                    {n.price}
                  </span>
                </div>
                <p className="text-charcoal-light font-light text-sm leading-relaxed" data-id="element-611">
                  {n.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Investment & Economy */}
      <section className="py-24 px-6 bg-white" data-id="element-612">
        <div className="max-w-7xl mx-auto" data-id="element-613">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-614">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-8" data-id="element-615">
              <div data-id="element-616">
                <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-617">
                  Smart Investment
                </span>
                <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-618">
                  Why Investors Love NLV
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-619">
                <div className="bg-warmGray p-6 border border-warmGray-dark" data-id="element-620">
                  <TrendingUp className="w-6 h-6 text-gold mb-3" data-id="element-621" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-622">
                    Strong Appreciation
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-623">
                    Property values have seen some of the highest appreciation
                    rates in the valley over the past 5 years.
                  </p>
                </div>
                <div className="bg-warmGray p-6 border border-warmGray-dark" data-id="element-624">
                  <Home className="w-6 h-6 text-gold mb-3" data-id="element-625" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-626">
                    Rental Demand
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-627">
                    High demand for rentals near Nellis AFB and the growing
                    industrial corridor creates excellent cash flow
                    opportunities.
                  </p>
                </div>
                <div className="bg-warmGray p-6 border border-warmGray-dark" data-id="element-628">
                  <Factory className="w-6 h-6 text-gold mb-3" data-id="element-629" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-630">
                    Job Growth
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-631">
                    Amazon, UNLV Tech Park, and major logistics companies are
                    driving unprecedented employment growth.
                  </p>
                </div>
                <div className="bg-warmGray p-6 border border-warmGray-dark" data-id="element-632">
                  <MapPin className="w-6 h-6 text-gold mb-3" data-id="element-633" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-634">
                    New Infrastructure
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-635">
                    Billions in new roads, schools, and commercial development
                    are transforming the area rapidly.
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-636">
              <div className="relative h-[600px]" data-id="element-637">
                <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2873&auto=format&fit=crop" alt="Investment" className="w-full h-full object-cover" data-id="element-638" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-639"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Things To Do */}
      <section className="py-24 bg-warmGray px-6 border-t border-warmGray-dark" data-id="element-640">
        <div className="max-w-7xl mx-auto" data-id="element-641">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-642">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-643">
              Entertainment
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-644">Things To Do</h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-645">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group" data-id="element-646">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-647">
                <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?q=80&w=2905&auto=format&fit=crop" alt="Speedway" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-648" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-649">
                Las Vegas Motor Speedway
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-650">
                Home to NASCAR races, drag racing, and driving experiences. One
                of the premier motorsports venues in the country.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group" data-id="element-651">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-652">
                <img src="https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=2940&auto=format&fit=crop" alt="Golf" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-653" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-654">
                Aliante Golf Club
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-655">
                A beautifully maintained 18-hole championship course with
                stunning desert and mountain views, open to the public.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="group" data-id="element-656">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-657">
                <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2940&auto=format&fit=crop" alt="Casino" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-658" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-659">
                Aliante Casino + Hotel
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-660">
                A full-service resort with dining, entertainment, a movie
                theater, and a relaxing pool area — all within the community.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <ListingsComingSoon area="North Las Vegas" data-id="element-661" />

      <ContactCTA data-id="element-662" />
    </main>;
}